import React, { useContext } from 'react';
import EDButton from '../../../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIconButton from '../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDIcon from '../../../../../../../BaseComponents/Icon/EDIcon';
import { TEDLRFakturaDelATTEST_STATUSEnum } from '../../../../../../../globalQueryTypes';
import { useIsSmallScreen } from '../../../../../../../Hooks/useFullscreenView';
import { BusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import FakturaDelContext from '../FakturaDelContextManager/FakturaDelContext';

interface IProps {
  onClick: () => void;
}

const statuses = [
  TEDLRFakturaDelATTEST_STATUSEnum.DEFINITIVBOKAD,
  TEDLRFakturaDelATTEST_STATUSEnum.BETALD,
  TEDLRFakturaDelATTEST_STATUSEnum.DELBETALD,
  TEDLRFakturaDelATTEST_STATUSEnum.MAKULERAD,
];

const ShowBokfKonteringarButton: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const formContext = useContext(BusinessDataFormContext);
  const fakturadelContext = useContext(FakturaDelContext);
  const isSmallScreen = useIsSmallScreen();

  return (
    <>
      {statuses.some(status => status === formContext?.data?.ATTEST_STATUS) &&
        fakturadelContext.konteringsforslag.some(
          kf => kf.BokfortAvvikande === 'Y' || kf.BokfortAvvikande === 'S'
        ) && (
          <>
            {isSmallScreen ? (
              <EDIconButton
                color="primary"
                icon="inventory"
                margin="dense"
                onClick={props.onClick}
                padding="dense"
                tooltip="Visa bokförda konteringar"
              />
            ) : (
              <EDButton
                flat
                label="Visa bokförda konteringar"
                icon={<EDIcon color="primary" iconType="inventory" />}
                onClick={props.onClick}
              />
            )}
          </>
        )}
    </>
  );
};

export default ShowBokfKonteringarButton;
